import { request } from '@/utils/index';
import {
  UpdateUserReportPreferencesParams,
  UserReportPreferencesRequestsInterface,
} from './interfaces';

const updateUserReportPreferences = async (
  bodyParams: UpdateUserReportPreferencesParams
) => {
  return await request('/api/v5/user_report_preferences', {
    method: 'PATCH',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify(bodyParams),
  });
};

export const UserReportPreferencesRequests: UserReportPreferencesRequestsInterface =
  {
    updateUserReportPreferences,
  };
